import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class RoleChangeService {
  private roleIdSource = new BehaviorSubject<string | null>(
    localStorage.getItem("RoleId")
  );
  currentRoleId = this.roleIdSource.asObservable();

  constructor() {}

  changeRole(newRoleId: string) {
    this.roleIdSource.next(newRoleId);
  }
}
